// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorMessage_error__phhgC","errors":"ErrorMessage_errors__tzqwL","key":"ErrorMessage_key__CiOgv"};